import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { getRowHeight, getRowClassName } from 'utils/commonUtils';

export const getAssetNotesDataGrid = (columns, assetNotes) => {
  return (
    <DataGridPro
      //density='compact'
      autoHeight
      getRowHeight={getRowHeight}
      getRowClassName={(params) => getRowClassName(params)}
      columns={columns}
      rows={assetNotes}
      sx={{ flex: 1 }}
      hideFooter
    />
  );
};
